module.exports = __webpack_public_path__ + "img/Weapon_161.34a2c3ec.png";